import { noop } from '@philips-internal/oswald-ui-utils';
class EventBus extends Map {
    get(key) {
        if (!this.has(key)) {
            this.set(key, []);
        }
        return super.get(key);
    }
    insert(key, callback) {
        const set = this.get(key);
        if (set) {
            set.push(callback);
            return () => {
                const index = set.indexOf(callback);
                set.splice(index, 1);
            };
        }
        return noop;
    }
}
export { EventBus, };
//# sourceMappingURL=event-bus.js.map